import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"

export function Hero() {
  return (
    <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <div className="space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-forest/10 text-forest px-4 py-2 rounded-full text-sm font-medium">
              <span className="w-2 h-2 bg-forest rounded-full animate-pulse" />
              Community-powered discovery
            </div>

            {/* Headline */}
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground leading-tight tracking-tight text-balance">
              Your neighbourhood,{" "}
              <span className="text-forest">connected.</span>
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl">
              Discover local events, support independent retailers, and strengthen your
              community through a platform built by and for the people who call it home.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-forest hover:bg-forest-light text-cream rounded-full px-8 h-14 text-base font-medium shadow-lg shadow-forest/20"
              >
                Join the Waitlist
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="rounded-full px-8 h-14 text-base font-medium border-2 border-border hover:bg-secondary bg-transparent"
              >
                See How It Works
              </Button>
            </div>
          </div>

          {/* Right: WhatsApp Mockup */}
          <div className="relative lg:pl-8">
            <div className="relative mx-auto max-w-[320px]">
              {/* iPhone Frame */}
              <div className="relative bg-gray-900 rounded-[3rem] p-3 shadow-2xl">
                {/* Notch */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-gray-900 rounded-b-2xl z-10" />

                {/* Screen */}
                <div className="bg-[#e5ddd5] rounded-[2.5rem] overflow-hidden">
                  {/* WhatsApp Header */}
                  <div className="bg-[#075e54] text-white px-4 py-3 pt-10">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-forest flex items-center justify-center">
                        <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 text-cream" stroke="currentColor" strokeWidth="2">
                          <rect x="3" y="3" width="18" height="18" rx="2" />
                          <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
                          <circle cx="15.5" cy="8.5" r="1.5" fill="currentColor" />
                        </svg>
                      </div>
                      <div>
                        <p className="font-semibold text-sm">Corkboard</p>
                        <p className="text-xs opacity-80">online</p>
                      </div>
                    </div>
                  </div>

                  {/* Chat Messages */}
                  <div className="p-3 space-y-2 min-h-[380px]">
                    {/* User Message */}
                    <div className="flex justify-end">
                      <div className="bg-[#dcf8c6] rounded-lg rounded-tr-none px-3 py-2 max-w-[85%] shadow">
                        <p className="text-sm text-gray-800">What's on this weekend?</p>
                        <p className="text-[10px] text-gray-500 text-right mt-1">10:32</p>
                      </div>
                    </div>

                    {/* Bot Response */}
                    <div className="flex justify-start">
                      <div className="bg-white rounded-lg rounded-tl-none px-3 py-2 max-w-[90%] shadow">
                        <p className="text-sm text-gray-800 mb-2">Hey! Based on your interests, here are some picks for this weekend:</p>

                        {/* Event 1 */}
                        <div className="bg-forest/10 rounded-lg p-2 mb-2">
                          <p className="text-xs font-semibold text-forest">🎸 The Remedy @ The Clarendon</p>
                          <p className="text-xs text-gray-600">Fri 8pm • Live indie rock</p>
                        </div>

                        {/* Event 2 */}
                        <div className="bg-amber/10 rounded-lg p-2 mb-2">
                          <p className="text-xs font-semibold text-amber">🍲 Food Bank Volunteer Day</p>
                          <p className="text-xs text-gray-600">Sat 10am • St Nicholas Church</p>
                        </div>

                        {/* Event 3 */}
                        <div className="bg-forest/10 rounded-lg p-2">
                          <p className="text-xs font-semibold text-forest">💻 Corkboard Codecamp</p>
                          <p className="text-xs text-gray-600">Sat 2pm • Kenilworth Library</p>
                        </div>

                        <p className="text-[10px] text-gray-500 text-right mt-2">10:32</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating Label */}
              <div className="absolute -bottom-4 -left-4 bg-card border border-border px-4 py-3 rounded-2xl shadow-lg hidden md:block">
                <p className="text-xs text-muted-foreground mb-1">Powered by</p>
                <p className="text-sm font-semibold text-forest">Responsible AI</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
